import Common from "../modules/common";

const category = {
  init() {
    this.events();
  },

  events() {
    $(".load-more").on("click", (e) => {
      const btnEl = $(e.currentTarget);
      category.loadMore(btnEl);
    });
  },

  loadMore(btnEl) {
    btnEl.attr("disabled", true);

    let page = Number(btnEl.attr("data-page"));
    page++;
    btnEl.attr("data-page", page);

    const data = {
      action: "newsroom_load_more",
      cat: btnEl.data("id"),
      page,
    };

    $.ajax({
      type: "POST",
      url: Sage.ajaxurl,
      data,
    }).done((response) => {
      if (!response.more) {
        btnEl.remove();
      } else {
        btnEl.attr("disabled", false);
      }

      if (response.posts) {
        $(".newsroom-category__items").append(response.posts);
        Common.lazyLoadInstance.update();
      }
    });
  },
};

export default category;
